import { errorMapper } from '../mappers/error-mapper';
import { apiClient } from '../shared/api-client';

const surveyRepository = {
    async sendResults(body) {
        try {
            const data = await apiClient.post({
                url: 'survey/results',
                body
            });

            return data;
        } catch (error) {
            throw errorMapper.toDomain(error);
        }
    }
};

export {
    surveyRepository
};
